import type { PropsElement } from '../props';
import type { ToolFn, ToolSpec } from '../types';

export const propertiesSpec: ToolSpec = {
  name: 'list_properties',
  description:
    'Property sets, base quantities and material of one element by expressID. Quantities are in m, m² and m³.',
  input_schema: {
    type: 'object',
    properties: { id: { type: 'integer' } },
    required: ['id'],
  },
};

export const properties =
  (elements: PropsElement[]): ToolFn =>
  ({ id }) => {
    const e = elements.find((x) => x.expressID === Number(id));
    if (!e) return { error: 'not found' };
    return {
      id: e.expressID,
      type: e.type,
      name: e.name,
      storey: e.storey,
      material: e.material ?? null,
      quantities: e.quantities ?? {},
      derived: e.derived ?? null,
      psets: e.psets ?? {},
    };
  };
